// extracted by mini-css-extract-plugin
export default {"button":"Fw98G","icon":"K9iLz","facebook":"-XvvY","twitter":"zPNjJ","link":"IjfYo","share":"_2Kwcs"};